import axios from 'axios';

const API_BASE_URL = "https://api.giftydev.opus.win/api/external/payment";

// Fetch cart data
export const getPurchaseData = async (key) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/` + key);
        return response.data;
    } catch (error) {
        console.error("Error fetching cart data:", error);
        throw error;
    }
};

// Store purchase data
export const storePurchaseData = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/store`, data);
        return response;
    } catch (error) {
        console.error("Error processing payment:", error);
        throw error;
    }
};


export const cancelOrder = async (data) => {
    try {
        const response = await axios.post(`${API_BASE_URL}/cancel` , data);
        return response;
    } catch (error) {
        console.error('error :>> ', error);
        throw error;
    }
}



